import { WIDGET_VIEW_STRING } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const StringViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_STRING,
  component: () => import("./string-view-widget.component").then((m) => m.StringViewWidgetComponent)
};
